import React from 'react'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import * as SideMenu from 'components/side-menu'
import { store } from 'store/index'

export const StoriesLink = () => {
  const path = `/stories`
  const title = 'Stories'

  const isActive = useIsActive(path, null, { exactMatch: false })

  if (!store.featureFlags.featureEnabled('stories')) return null

  return (
    <SideMenu.LinkItem
      active={isActive}
      href={path}
      analyticsProps={sideNavAnalyticsProps({
        href: path,
        title,
      })}
      data-element-id="side-nav-stories-link"
    >
      {title}
    </SideMenu.LinkItem>
  )
}
